export default __webpack_public_path__ + "static/media/relaunch.41aac302.svg";